import React from 'react';
import { TextareaField } from '../../../../../components/FormikFields';

export const rejectAgreementFormConfig = ({ t, typeLabel, isAmendment }) => [
  {
    fields: [
      {
        name: 'reason',
        label: t(
          isAmendment
            ? 'special_billing.reject-amendment_reason_label'
            : 'special_billing.reject_reason_label',
          { type: typeLabel },
        ),
        labelClassName: 'reasonLabel',
        component: TextareaField,
        componentProps: {
          className: 'reasonField',
          placeholder: t(
            isAmendment
              ? 'special_billing.reject-amendment_reason_placeholder'
              : 'special_billing.reject_reason_placeholder',
            { type: typeLabel },
          ),
        },
        required: false,
      },
    ],
  },
];
